import { render, staticRenderFns } from "./request-item-card.vue?vue&type=template&id=16e632ac&"
import script from "./request-item-card.vue?vue&type=script&lang=js&"
export * from "./request-item-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports